<article class="bk-panel mcc" [attr.aria-label]="subject">
  <header class="mcc__head">
    <div class="mcc__title">
      @if (index !== null) {
        <p class="bk-eyebrow">Message {{ index + 1 }}</p>
      }
      <h3 class="mcc__subject">{{ subject }}</h3>
      @if (from) {
        <p class="mcc__from">from {{ from }}</p>
      }
    </div>

    <span class="bk-row-actions">
      <button
        type="button"
        class="bk-icon-btn"
        aria-label="Edit message"
        matTooltip="Edit message"
        (click)="showEdit = true"
      >
        <span class="bk-sym" aria-hidden="true">edit</span>
      </button>
      <button
        type="button"
        class="bk-icon-btn mcc__danger"
        aria-label="Delete message"
        matTooltip="Delete message"
        (click)="showDelete = true"
      >
        <span class="bk-sym" aria-hidden="true">delete</span>
      </button>
    </span>
  </header>

  <!-- The copy as a handset shows it, with the SMS parts it costs -->
  <bk-sms-bubble [text]="copy" />

  <div class="mcc__row">
    <span class="mcc__label">Delivery</span>
    <bk-delivery [uuid]="uuid" [status]="deliveryStatus" [sentAt]="sentAt" />
  </div>

  <section class="mcc__schedules" [attr.aria-label]="'Schedules for ' + subject">
    <div class="mcc__schedules-head">
      <span class="mcc__label">Schedules</span>
      <button type="button" class="bk-more" (click)="showSchedule = true">
        {{ schedules.length ? "Manage schedules" : "Add a schedule" }}
        <span class="bk-sym" aria-hidden="true">arrow_outward</span>
      </button>
    </div>

    @if (schedules.length) {
      <ul class="mcc__list">
        @for (row of schedules; track row.key) {
          <li class="mcc__item" [class.is-past]="row.past">
            <span class="mcc__when" [attr.title]="row.exact">
              {{ row.when }}
              @if (row.zone) {
                <span class="mcc__zone">{{ row.zone }}</span>
              }
            </span>
            <span class="mcc__state">
              @if (!row.past && !row.stopped) {
                <span class="mcc__countdown">{{ row.countdown }}</span>
              }
              @if (row.status) {
                <app-status [text]="row.status" [status]="row.status" />
              } @else if (row.past) {
                <span class="mcc__quiet">Sent</span>
              }
            </span>
          </li>
        }
      </ul>
    } @else {
      <p class="mcc__quiet">Not scheduled. Add a schedule to send this message.</p>
    }
  </section>

  @if (showSchedule) {
    <app-message-schedules
      (onClose)="showSchedule = false"
      [openModal]="showSchedule"
      [message]="message"
    ></app-message-schedules>
  }
  @if (showEdit) {
    <app-edit-message
      [message]="message"
      (onClose)="showEdit = false"
      [openModal]="showEdit"
      [campaignData]="campaignData"
    ></app-edit-message>
  }

  <!-- delete popup -->
  @if (showDelete) {
    <app-prompt-card
      [openModal]="showDelete"
      title="Delete message"
      buttonText="Delete message"
      tone="danger"
      closeText="Keep message"
      (onClose)="showDelete = false"
      (onButtonClick)="deleteMessage(message.id)"
      [loading]="campaignsService.isLoading"
    >
      <p class="mcc__prompt">
        Delete <strong>{{ subject }}</strong> and its schedules from this
        campaign? This cannot be undone.
      </p>
    </app-prompt-card>
  }
</article>
